var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPositiveVariation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0435 3.16675H2.33341V0.166748H13.7772H15.2772V1.66675V13.3334H12.2772V5.17571L3.06078 14.3922L0.939453 12.2708L10.0435 3.16675Z",
    fill: "#00FF6C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPositiveVariation);
export default __webpack_public_path__ + "static/media/positive-variation.0552a55264924334d6d7d08598045e19.svg";
export { ForwardRef as ReactComponent };